import './OrderDetailCheckPage.scss'

import { EnvironmentOutlined, LeftOutlined } from '@ant-design/icons'
import { Button, Divider, message, Spin } from 'antd'
import { getFormattedPrice } from 'helpers/Formatting'
import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useSiparisDetayQuery } from '../../../gql/GeneratedGraphqlTypes'
import { ReactComponent as MoneyIcon } from './images/payment.svg'
import { ReactComponent as PaymentIcon } from './images/paymentIcon.svg'

const OrderDetailCheckPage = () => {
  const { siparisId } = useParams()
  const navigate = useNavigate()
  const [messageApi, contextHolder] = message.useMessage()
  const temp = parseInt(siparisId || '1')
  const { data, error } = useSiparisDetayQuery({
    variables: { siparis_id: temp },
  })

  useEffect(() => {
    if (error) {
      messageApi.error(`${error}`, 2)
    }
  }, [error, messageApi])

  if (!data) {
    return (
      <>
        <Spin />
      </>
    )
  }

  const handleGeriDonClick = () => {
    navigate(-1)
  }

  return (
    <>
      {contextHolder}
      <div className="orders-detail-check-page">
        <div className="check-container">
          <div className="address-info">
            <div className="address-title">
              <EnvironmentOutlined />
              <span> Adres Bilgileri </span>
            </div>
            <div className="address-line">
              Teslimat Adresi
              <span>
                {data.siparisDetay.teslimat_adresi.isim}<br />
                {data.siparisDetay.teslimat_adresi.adres}<br />
                {data.siparisDetay.teslimat_adresi.ilce} / {data.siparisDetay.teslimat_adresi.il}<br />
                {data.siparisDetay.teslimat_adresi.gsm || data.siparisDetay.teslimat_adresi.tel}
              </span>
            </div>
            <Divider />
            <div className="address-line">
              Fatura Adresi
              <span>
                {data.siparisDetay.fatura_adresi.firma
                  ? `${data.siparisDetay.fatura_adresi.firma} — ${data.siparisDetay.fatura_adresi.vergi_dairesi} / ${data.siparisDetay.fatura_adresi.vergi_no}`
                  : data.siparisDetay.fatura_adresi.isim}<br />
                {data.siparisDetay.fatura_adresi.adres}<br />
                {data.siparisDetay.fatura_adresi.ilce} / {data.siparisDetay.fatura_adresi.il}
              </span>
            </div>
          </div>
          <div className="payment-info">
            <div className="header">
              <span className="payment-title">
                <MoneyIcon />
                Ödeme Bilgileri{' '}
              </span>
              <span className="line-count">{data.siparisDetay.satirlar.length} Adet Ürün </span>
            </div>
            <div className="payment-content">
              <div className="payment">
                Ödeme Tipi
                <span>{data.siparisDetay.odeme_tipi === 'Havale' ? ' Havale' : data.siparisDetay.kredi_karti_pos}</span>
              </div>
              {data.siparisDetay.kargo_ucreti && parseFloat(data.siparisDetay.kargo_ucreti) > 0 && (
                <div className="payment">
                  Kargo Bedeli
                  <span>{getFormattedPrice(data.siparisDetay.kargo_ucreti)}₺</span>
                </div>
              )}
              <div className="payment">
                Toplam Tutar
                <span className="total">{getFormattedPrice(data.siparisDetay.toplam_tutar)}₺</span>
              </div>
              <div className="payment">
                Ödeme Durumu
                <span className={`payment-status ${data.siparisDetay.durum === 'Ödemesi Geldi' ? 'paid' : 'pending'}`}>
                  {data.siparisDetay.durum}
                </span>
              </div>
              {data.siparisDetay.kredi_karti_vade_secenegi ? (
                <div className="payment">
                  Taksit Sayısı
                  {data.siparisDetay.kredi_karti_vade_secenegi}
                </div>
              ) : null}
              <PaymentIcon />
            </div>
          </div>
        </div>
        <div>
          <Button type={'primary'} className="account-detail-back-btn" icon={<LeftOutlined />} block onClick={handleGeriDonClick}>
            Geri Dön
          </Button>
        </div>
      </div>
    </>
  )
}

export default OrderDetailCheckPage
